import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Scales } from '@phosphor-icons/react';

const TermsOfServicePage = () => {
  const navigate = useNavigate();

  return (
    <div className="hb-bg">
      <div style={{ width: '100%' }} className="min-h-screen">
        {/* Header */}
        <header className="hb-header sticky top-0 z-50">
          <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <img src="/harperbids-logo.png" alt="HarperBids" className="h-10 hb-logo-glow" />
              <div>
                <h1 className="text-lg font-bold font-heading" style={{ color: 'var(--gold-light)' }}>HARPERBIDS</h1>
                <p className="text-xs" style={{ color: 'var(--text-muted)' }}>Terms of Service</p>
              </div>
            </div>
            <button
              data-testid="tos-back-button"
              onClick={() => navigate(-1)}
              className="flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-semibold transition-all"
              style={{ background: 'rgba(201,206,211,0.1)', border: '1px solid rgba(201,206,211,0.2)', color: 'var(--gold)' }}
            >
              <ArrowLeft size={14} weight="bold" />
              Back
            </button>
          </div>
        </header>

        {/* Content */}
        <main className="max-w-4xl mx-auto px-6 pt-10 pb-20">
          {/* Title */}
          <div className="flex items-center gap-4 mb-3">
            <Scales size={32} weight="duotone" style={{ color: 'var(--gold)' }} />
            <h1 className="text-3xl font-bold font-heading" style={{ color: 'var(--gold-light)' }}>Terms of Service</h1>
          </div>
          <p className="text-sm mb-10" style={{ color: 'var(--text-muted)' }} data-testid="tos-effective-date">
            Effective Date: April 14, 2026
          </p>

          {/* Terms Body */}
          <div className="hb-glass-strong space-y-8" data-testid="tos-content">
            <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
              These Terms govern your use of HarperBids, operated by Alpha 3 Group LLC.
            </p>

            {/* 1. The Service */}
            <section>
              <h2 className="text-lg font-bold font-heading mb-3" style={{ color: 'var(--gold-light)' }}>1. The Service</h2>
              <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
                HarperBids is a platform that connects contractors with building owners for potential business relationships. We are not a party to any agreements made between users.
              </p>
            </section>

            {/* 2. No Guarantees */}
            <section>
              <h2 className="text-lg font-bold font-heading mb-3" style={{ color: 'var(--gold-light)' }}>2. No Guarantees</h2>
              <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
                We make no guarantees about the quality, safety, or legitimacy of any user. You are solely responsible for verifying any party you choose to work with.
              </p>
            </section>

            {/* 3. Limitation of Liability */}
            <section>
              <h2 className="text-lg font-bold font-heading mb-3" style={{ color: 'var(--gold-light)' }}>3. Limitation of Liability</h2>
              <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
                Alpha 3 Group LLC and HarperBids shall not be liable for any damages, losses, or disputes that arise between users. This includes any business deals, contracts, or projects that result from connections made on our platform.
              </p>
            </section>

            {/* 4. User Conduct */}
            <section>
              <h2 className="text-lg font-bold font-heading mb-3" style={{ color: 'var(--gold-light)' }}>4. User Conduct</h2>
              <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
                Users must be legitimate businesses. Fake profiles, spam, or harassment will result in immediate account termination.
              </p>
            </section>

            {/* 5. Governing Law */}
            <section>
              <h2 className="text-lg font-bold font-heading mb-3" style={{ color: 'var(--gold-light)' }}>5. Governing Law</h2>
              <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
                These terms are governed by the laws of the State of Texas.
              </p>
            </section>

            {/* Contact */}
            <div className="pt-4" style={{ borderTop: '1px solid var(--border-subtle)' }}>
              <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
                For questions, contact:{' '}
                <a href="mailto:admin@harperbids.com" className="font-semibold" style={{ color: 'var(--gold)' }} data-testid="tos-email-contact">admin@harperbids.com</a>
              </p>
            </div>

            {/* Company */}
            <p className="text-sm font-semibold" style={{ color: 'var(--text-muted)' }}>
              Alpha 3 Group LLC
            </p>
          </div>
        </main>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
